export default __webpack_public_path__ + "static/media/light-vehicle.f192ad53.svg";